import {formatCurrency} from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {select, Store} from '@ngrx/store';
import {
  selectSubscriptionStoragePriceID,
  StorageAndInterval,
  StripePaymentSelectionService
} from '@spout/global-web/data-access';
import {Observable, Subject} from 'rxjs';
import {distinctUntilChanged, map, takeUntil} from 'rxjs/operators';

@Component({
  selector: 'spt-addon-storage',
  templateUrl: './addon-storage.component.html',
  styleUrls: ['./addon-storage.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddonStorageComponent implements OnInit, OnDestroy {
  private _onDestroy$: Subject<boolean> = new Subject();

  storagePriceIDForm = new UntypedFormControl(null);

  selectStorageQtyAndInterval$: Observable<string>;

  constructor(
    private _store: Store,
    public payment: StripePaymentSelectionService
  ) {
    this.selectStorageQtyAndInterval$ =
      this.payment.selectStorageQtyAndInterval$.pipe(
        map((s: StorageAndInterval) => {
          let price = 0;

          if (s.selectedProductPrice) {
            price = this.payment.baseStoragePrice * s.additionalStoragePerGB;
          }

          if (s.interval === 'year') {
            price *= 12;
          }

          return `${this.formatCurrency(price)} / ${s.interval}`;
        })
      );
  }

  @Output() priceChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() quantityChange: EventEmitter<number> = new EventEmitter<number>();

  ngOnInit(): void {
    this.storagePriceIDForm.valueChanges
      .pipe(takeUntil(this._onDestroy$))
      .subscribe((priceID: string) => {
        if (priceID) {
          this.priceChange.next(priceID);
        }
      });

    this._store
      .pipe(
        select(selectSubscriptionStoragePriceID),
        distinctUntilChanged(),
        takeUntil(this._onDestroy$)
      )
      .subscribe((planPriceID: string | null) => {
        if (planPriceID) {
          this.storagePriceIDForm.setValue(planPriceID);
        }
      });
  }

  ngOnDestroy() {
    this._onDestroy$.next(true);
  }

  formatCurrency(p: number): string {
    return formatCurrency(p / 100, 'en-US', '$', 'USD', '1.2-2');
  }
}
